var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-item',{attrs:{"card":"item_process","tabs":_vm.tabs,"activeTab":_vm.activeTab,"id":_vm.id,"isFull":true,"infoKeys":_vm.infoKeys},on:{"setTab":_vm.setTab}})}
var staticRenderFns = []

export { render, staticRenderFns }